import styles from './IconButton.module.scss';

export type IconButtonSize = 'large' | 'medium' | 'small';
export type IconButtonVariant = 'tertiary' | 'outlined';

export interface IconButtonProps {
  /** The icon to display inside the button */
  children: React.ReactNode;
  /** Visual variant */
  variant?: IconButtonVariant;
  /** Size variant */
  size?: IconButtonSize;
  /** Click handler */
  onClick?: () => void;
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Accessible label for the button */
  'aria-label': string;
  /** Additional CSS classes */
  className?: string;
}

const sizeToIconSize: Record<IconButtonSize, number> = {
  large: 20,
  medium: 22,
  small: 14,
};

export const IconButton = ({
  children,
  variant = 'tertiary',
  size = 'medium',
  onClick,
  disabled = false,
  'aria-label': ariaLabel,
  className = '',
}: IconButtonProps) => {
  const containerClassName = [
    styles.container,
    styles[size],
    styles[variant],
    disabled && styles.disabled,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      className={containerClassName}
      onClick={handleClick}
      disabled={disabled}
      aria-label={ariaLabel}
      type="button"
    >
      <span className={styles.iconWrapper} style={{ width: sizeToIconSize[size], height: sizeToIconSize[size] }}>
        {children}
      </span>
    </button>
  );
};
